import Alert from '../Alert/Alert';

function SuccessMessage(props) {
    return (
        <>
            {props.success.map((data, key) => {
                const message = data.message ? data.message : data;
                return (
                    <Alert key={key} variant="success" body={message} />
                );
            })}
        </>
    );
}

export default SuccessMessage;